<template> 
    <div style="background:#fff;line-height:30px;height:40px;border-bottom:2px solid #389;height:100% "> 
        <div style="padding-top:3px;display:flex">
         <div style="font-size:13px;width:70px;padding-left:2px">字段查询</div>   
        <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:130px;  ">
            <span v-for="item in tabCol" :key='item.key'>
                <el-option :label="item.title" :value="item.key"></el-option>
            </span>
        </el-select>
        <el-input placeholder="请输入查询值" ref="refqry" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:330px; height:30px;  ">
            <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            <el-select v-model="oper" slot="prepend" size="small" style="width:110px;" >
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
        </el-input>   
        </div>
        <el-table :data="tmpData" 
                border          
                class="custom-table-border"                  
                disabled-hover
                style="overflow:auto;margin-top:3px;"
                v-loading="loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                size="small"
                ref="reftab"
                :height="tabHeight" 
                :max-height="tabHeight" 
                :row-key="getRowKey"
                highlight-current-row>
                <el-table-column label="序号" type="index" width="60"></el-table-column>
            <span  v-for="(item ,index) in tabCol" :key="index">   
                <el-table-column   v-if="item.thide==='N' &&item.key!=='STFG'"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
                <el-table-column  v-if="item.key==='STFG'"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :min-width="item.width">
                    <template  slot-scope="scope" >
                        <el-checkbox disabled  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                    </template>
                </el-table-column>
            </span> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="170">
                <template slot-scope="scope">
                    <span v-if="scope.row.STFG!=='Y'">
                        <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'Y' )" :underline="false"  ><span style="font-size:11px;margin-right:15px;">通过 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y'">
                        <i class="iconfont icon-cuowukongxin" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cancelBool" @click="stfgRec(scope.row,'R')" :underline="false"  ><span style="font-size:11px;margin-right:15px;">拒绝 </span></el-link>
                    </span>
                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="editBool" @click="editRec(scope.row )" :underline="false"  ><span style="font-size:11px;margin-right:15px;">编辑备注 </span></el-link>
                </template>
            </el-table-column>                       
        </el-table>

        <el-dialog :visible.sync="editWin" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑备注</span>
            </div> 
            <el-input v-model="editrmk" placeholder="请输入备注内容"></el-input>
            <span slot="footer"  >
                <el-button size="small" type="text" icon="iconfont icon-shanchu" @click="editWin = false" style="margin-right:20px;">取 消</el-button>
                <el-button size="small" type="text" icon="iconfont icon-baocun" @click="editOk" style="margin-right:20px;">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 提示 -->
        <el-dialog :visible.sync="dialogVisible" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import {getDate} from '../../api/Select' 
export default {
    name: 'sys_accdb',
    data () {
        return {
            oper:'like',
            rowIdseq:'', // 
            prompt:'', // 
            dialogVisible:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'USERNO',// select 绑定值
            txtparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            tmpData:[] ,// 
            operArr:[],
            baseData:[] ,//表数据
            editWin:false ,//  
            orgData:[] ,//组织部门
            editrmk:'',//  
            rowLstseq:'' ,//
            disabled:false,
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
 
            v_url:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
 
            stfgBool:true,
            formCol:{}, //表格单行记录 model
  
            notNull:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        this.getFormData('') //初始查询表数据   
 
    },
    components: {
 
    },
    mounted () {   
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        this.$refs.refqry.focus()
         //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','4246','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                console.log(JSON.stringify(row))
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -130
        },
        scrollerHeight: function() {
            return (window.innerHeight - 80) + 'px';
        }, 
    },
    methods: {  
        getRowKey(row){
            return row.PKSEQ
        },
 
        //修改记录
        editRec(row){
            this.editWin=true
            this.editrmk=row.RMK
            this.rowIdseq=row.IDSEQ
            this.rowLstseq=row.LSTSEQ
        },
        editOk(){
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.rowIdseq,p_key2:'lstseq',p_value2:this.rowLstseq,p_table:'SYS_DBDTL',p_cond:' set rmk=\''+this.editrmk +'\' ' },
            }).then(res=>{      
                if(res.code =='200')  {  
                    this.editWin=false         
                    this.qryTabData() 
                }else{
                    this.dialogVisible=true
                    this.prompt=res.result
                }        
            }) 
        },
        //状态变更
        stfgRec(row,val){
            let stfg_ =val==='Y'?'通过':'拒绝'
            this.$confirm('你确定要'+stfg_+'此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'SYS_DBDTL',p_cond:' set stfg=\''+val+'\',upddttm=\''+getDate('full')+'\',upduser=\''+this.v_username+'\' ' },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData() 
                    }else{
                        this.dialogVisible=true
                        this.prompt=res.result
                    }        
                }) 
                 
            }).catch(()=>{})
           
        },
 
        //查询选择器事件
        elchange(value){
            let obj ={}
            obj =this.tabCol.find(item=>{
                return item.key===value
            })
            this.input_hold='请输入'+obj.title+' 的值'
        },
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
            }
            this.getFormData(cond_ )
        },
 
        //获取表单数据
        getFormData(  cond){
            var vm=this
            this.loading =true
            getTabColOrData(this.v_url,'v_sys_dbdtl','corpid',this.v_corpid,'','','','',cond).then((res) => {              
                if (res.code==='200'){
                    this.tmpData=res.result  
                    if (res.result.length>0)
                    this.$refs['reftab'].setCurrentRow(res.result[0])  
                }else{
                    this.dialogVisible=true
                    this.prompt=res.result
                }
                vm.loading =false         
            });            
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4246','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            });
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
